module.exports = __webpack_public_path__ + "img/ab-first.ea80726a.png";